import { derived } from 'svelte/store';
import { isCriticalError } from 'Utils/isCriticalError';
import { dictionary, locale, _ } from 'svelte-i18n';
import { sentryHub, SentryErrorType } from "Utils/sentryHelper";

let messages

// const availableLocale = ["bg", "de", "el", "en", "es", "fi", "fr", "fr-CA", "id", "id", "ja", "ko", "nl", "nn", "pl", "pt", "pt-BR", "ro", "ru", "sv", "th", "tr", "uk", "vi", "zh"]

async function setupI18n({ withLocale: _locale } = { withLocale: 'en' }) {


    // if (!availableLocale.includes(_locale)) {
    //     console.log("Error unsupported locale " + _locale)
    //     sentryHub.captureMessage("Error unsupported locale " + _locale)
    //     return
    // }

    messages = await import(`/static/l10n/common/${_locale}.json`).catch(error => {
        console.error("Error  can't load User locale " + _locale + " : " + error)
        //sentryHub.captureMessage("Error  can't load User locale " + _locale)
        sentryHub.captureMessage(SentryErrorType.OPTIONS_ERROR + " locale: " + _locale);

        isCriticalError.set(true)


    });

    if (messages) {
        dictionary.set({ [_locale]: messages });
        locale.set(_locale);
    }



}





const isLocaleLoaded = derived(locale, $locale => typeof $locale === 'string' && messages);

export { _, locale, setupI18n, isLocaleLoaded };